import { useEffect, useRef, useState } from "react"
import { useTranslation } from "react-i18next"
import CloseIcon from "@mui/icons-material/Close"
import {
  Avatar,
  Backdrop,
  Box,
  Button,
  DialogTitle,
  IconButton,
  Alert,
  Grid,
  Tab,
  Tabs,
} from "@mui/material"
import { useAppSelector, useAppDispatch } from "@/core/app/hooks"
import { RootState } from "@/core/app/store"
import { UText } from "@/components/index"
import { StageNumber } from "./StageNumber"
import { OrderLabel } from "./OrderLabel"
import { UndercutFill } from "./UndercutFill"
import { TrimLine } from "./TrimLine"
import { PrintOthers } from "./PrintOthers"
import SelectStage from "./SelectStage"
interface TabPanelProps {
  children?: React.ReactNode
  index: number
  value: number
}
const CustomTabPanel = (props: TabPanelProps) => {
  const { children, value, index, ...other } = props

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      style={{
        visibility: value === index ? "visible" : "hidden",
        height: value === index ? "auto" : 0,
      }}
    >
      {children}
    </div>
  )
}
export const OrderStlPrint = () => {
  const { caseDetail } = useAppSelector((state: RootState) => state.caseService)
  const { openStlPrint } = useAppSelector(
    (state: RootState) => state.udTreatService,
  )
  const dispatch = useAppDispatch()
  const [tabVal, setTabVal] = useState<number>(0)
  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setTabVal(newValue)
  }
  console.log("788", caseDetail)
  const getArch = (udesign_category) => {
    let caseArch = "both",
      UpperType = "A",
      LowerType = "A"

    if (!udesign_category) return caseArch
    UpperType = udesign_category.split("/")[0]

    LowerType = udesign_category.split("/")[1]

    if (UpperType.includes("--")) {
      caseArch = "lower"
    } else if (LowerType.includes("--")) {
      caseArch = "upper"
    }

    return { caseArch, UpperType, LowerType }
  }
  return (
    <Box sx={{ width: "100%" }}>
      <Box sx={{ width: "100%", textAlign: "center", marginBottom: "30px" }}>
        <UText variant={"h4"}>{`Order STL Print`}</UText>
      </Box>
      <Tabs
        value={tabVal}
        onChange={handleChange}
        aria-label="basic tabs example"
        sx={{
          "& .MuiTab-root": {
            padding: "9px 16px",
            fontSize: "14px",
            fontWeight: "500",
            minWidth: "unset",
            maxWidth: "unset",
            letterSpacing: "0.4px",
            textTransform: "capitalize",
          },
        }}
      >
        <Tab label="Stage number" />
        <Tab label="Label" />
        <Tab label="Undercut Fill" />
        <Tab label="Trim Line" />
        <Tab label="Others" />
      </Tabs>

      <Box
        sx={{
          background: "#fff",
          padding: "5px 10px",
          height: "280px",
        }}
      >
        <CustomTabPanel value={tabVal} index={0}>
          <StageNumber />
        </CustomTabPanel>
        <CustomTabPanel value={tabVal} index={1}>
          <OrderLabel />
        </CustomTabPanel>
        <CustomTabPanel value={tabVal} index={2}>
          <UndercutFill />
        </CustomTabPanel>
        <CustomTabPanel value={tabVal} index={3}>
          <TrimLine />
        </CustomTabPanel>
        <CustomTabPanel value={tabVal} index={4}>
          <PrintOthers />
        </CustomTabPanel>
      </Box>

      {/* stage */}
      <SelectStage />
    </Box>
  )
}
